import type { AppConfigInput } from '@nuxt/schema'

export default {
  separator: {
    slots: {
      label: 'text-(--grey-secondary) uppercase font-medium text-md w-[48px]',
    },
    variants: {
      type: {
        mobile: {
          border: 'border-4',
        },
      },
    },
    compoundVariants: [
      {
        orientation: 'horizontal',
        type: 'mobile',
        class: {
          root: 'w-screen -mx-4 md:hidden',
          border: 'border-(--grey-background)',
        },
      },
    ],
  },
} as AppConfigInput['ui']
